export type Hypervisor = 'VIRTUALBOX' | 'VMWARE' | 'HYPERV' | null;

export enum HypervisorType {
  VirtualBox = 'virtualbox',
  HyperV = 'hyperv',
  VMware = 'vmware',
}

export interface HypervisorOption {
  id: HypervisorType;
  hypervisor: Hypervisor;
  name: string;
  nameKey: string;
  descKey: string;
  fileExtension: string;
}

export namespace HypervisorType {
  export const options: readonly HypervisorOption[] = [
    {
      id: HypervisorType.VirtualBox,
      hypervisor: 'VIRTUALBOX',
      name: 'VirtualBox',
      nameKey: 'boxes.provisioning.hypervisors.virtualbox.name',
      descKey: 'boxes.provisioning.hypervisors.virtualbox.desc',
      fileExtension: '.ova',
    },
    {
      id: HypervisorType.HyperV,
      hypervisor: 'HYPERV',
      name: 'Hyper-V',
      nameKey: 'boxes.provisioning.hypervisors.hyperv.name',
      descKey: 'boxes.provisioning.hypervisors.hyperv.desc',
      fileExtension: '.vhdx.zip',
    },
    {
      id: HypervisorType.VMware,
      hypervisor: 'VMWARE',
      name: 'VMware',
      nameKey: 'boxes.provisioning.hypervisors.vmware.name',
      descKey: 'boxes.provisioning.hypervisors.vmware.desc',
      fileExtension: '.ova',
    },
  ];

  export function getOption(type: HypervisorType | Hypervisor | string): HypervisorOption | undefined {
    const normalized = String(type).toUpperCase();
    return options.find(
      (opt) =>
        opt.id === type ||
        opt.hypervisor === type ||
        opt.id.toUpperCase() === normalized ||
        opt.hypervisor === normalized,
    );
  }

  export function toHypervisor(type: HypervisorType | Hypervisor | string): Hypervisor {
    const normalized = String(type).toUpperCase();
    if (normalized.includes('HYPERV') || normalized.includes('HYPER-V')) return 'HYPERV';
    if (normalized.includes('VMWARE')) return 'VMWARE';
    return 'VIRTUALBOX';
  }
}
